import { render, staticRenderFns } from "./salary-tmp.vue?vue&type=template&id=1999b571"
import script from "./salary-tmp.vue?vue&type=script&lang=js"
export * from "./salary-tmp.vue?vue&type=script&lang=js"
import style0 from "./salary-tmp.vue?vue&type=style&index=0&id=1999b571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports